<template>
  <div >
    <!-- <el-row :gutter="20" style="margin-bottom:10px;">
      <el-col>
        <span class="fs-14 secondary-text">Total : {{stats.count}} </span>
        <span class="fs-14 secondary-text" style="margin-left:20px;" v-if="isFiltered">Total filtré : {{count}} <el-link type="text" @click="resetFilters"><i class="mdi mdi-filter-remove"/></el-link></span>
      </el-col>
    </el-row> -->
    <div style="margin:10px;">
      <el-row :gutter="20" type="flex" style="flex-wrap:wrap">
          <div class="select-info pt-5" v-if="mode!='tile'">
            <span v-if="selected.length==0 && !isFiltered" class="fs-14">{{$t('invoices.allInvoices')}} <span><el-button icon="el-icon-plus" circle size="small" @click="$emit('new')"></el-button></span></span>
            <span v-else>
              <span class="fs-14">{{$t(invoices.invoicesTitle)}}</span>
              <span v-if="selected.length==0 && isFiltered">
                <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> {{$t('common.SearchResults')}}</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{count}}</span>
              </span>
              <span v-else>
                <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> {{ $t('invoices.selected') }}</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{selected.length}}</span>
                <el-dropdown size="small" split-button type="primary" class="ml-20">
                  {{$t('common.Actions')}}
                  <el-dropdown-menu slot="dropdown">
                   <el-dropdown-item :disabled="true"><i class="el-icon-delete"></i>{{$t('invoices.actions.void')}}</el-dropdown-item>
                   <el-dropdown-item @click.native="downloadCSV"><i class="mdi mdi-file-excel"></i>{{$t('invoices.actions.exportCSV')}}</el-dropdown-item>
                   <el-dropdown-item @click.native="sendInvoices"><i class="el-icon-message"></i>{{$t('invoices.actions.send')}}</el-dropdown-item>
                   <el-dropdown-item :disabled="true"><i class="el-icon-delete"></i>{{$t('invoices.actions.duplicate')}}</el-dropdown-item>
                   <el-dropdown-item :disabled="true"><i class="el-icon-delete"></i>{{$t('invoices.actions.markAsSent')}}</el-dropdown-item>
                   <el-dropdown-item :disabled="true"><i class="el-icon-delete"></i>{{$t('invoices.actions.addPayment')}}</el-dropdown-item>
                   <el-dropdown-item :disabled="true"><i class="el-icon-delete"></i>{{$t('invoices.actions.downloadPDF')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </span>
          </div>
          <div class="search-box">
            <el-input
              :placeholder="$t('invoices.search')"
              clearable
              v-model="search"
              v-popover:popover>
              <el-dropdown slot="append" style="border-right:1px;">
                  <el-button type="primary">
                  <span class="hidden-md-and-down">{{$t('common.sortBy')}}</span><i class="el-icon-sort el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :icon="sortIcon('customer.name')" @click.native="sortBy('customer.name')">{{$t('invoices.sorting.customer')}}</el-dropdown-item>
                  <el-dropdown-item :icon="sortIcon('inv_number')" @click.native="sortBy('inv_number')">{{$t('invoices.sorting.number')}}</el-dropdown-item>
                  <el-dropdown-item  :icon="sortIcon('created_at')" @click.native="sortBy('created_at')">{{$t('invoices.sorting.creationDate')}}</el-dropdown-item>
                  <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">{{$t('invoices.sorting.lastUpdate')}}</el-dropdown-item>
                  <el-dropdown-item  :icon="sortIcon('date')" @click.native="sortBy('date')">{{$t('invoices.sorting.date')}}</el-dropdown-item>
                  <el-dropdown-item  :icon="sortIcon('paid_at')" @click.native="sortBy('paid_at')">{{$t('invoices.sorting.paymentDate')}}</el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
              <el-button slot="prepend" @click="showFilters=true"  class="text-left filter-button">
                <i class="mdi mdi-filter-variant" style="font-size:15px;">
                  <span v-if="getNbFiltersCriteria>0">{{getNbFiltersCriteria}}
                    <span class="hidden-md-and-down">
                      <span v-if="getNbFiltersCriteria==1">{{$t('common.filter')}}</span>
                      <span v-else>{{$t('common.filters')}}</span>
                      <span v-if="getNbFiltersCriteria==1"> {{$t('common.applied')}}</span>
                      <span v-else> {{$t('common.applieds')}}</span>
                    </span>
                    <el-link type="info" @click="resetFilters" class="ml-2">
                      <i class="mdi mdi-filter-remove"/>
                    </el-link>
                  </span>
                  <span v-else class="secondary-text fs-14"> <span class="hidden-md-and-down">{{$t('common.advancedFilters')}}</span></span>
                </i>
              </el-button>
            </el-input>
          </div>

      </el-row>
    </div>
    <div class="flex center m-10">
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="pages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <div class="box grow  item-list no-p" :style="getHeightStyle" v-loading="loading" v-if="mode=='tile'">
      <div class="infinite-list"  style="overflow:auto;" :style="getHeightStyle">
        <div v-for="(inv, index) in invoices" :key="inv.id" class="flex item no-p"  :class="{ active : (selectedInvoice!=null && selectedInvoice.id == inv.id) }" @click="$emit('select',index);">
          <InvoiceTile :customer="inv.customer" :inv_number="inv.inv_number" :reference="inv.reference" :date="inv.date" :total="inv.total" :status="inv.status" :files="inv.files" :currency="inv.currency" :sent="inv.sent_at!=null" :notice_status="inv.notice_status"></InvoiceTile>
        </div>
      </div>
    </div>
    <div v-else>
      <el-table
      :data="invoices"
      stripe
      v-loading="loading"
      :height="getHeight"
      :cell-style="{padding:'3px'}"
      :empty-text="$t('invoices.noInvoices')"
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        prop="inv_number"
        :label="$t('invoices.invoiceNumber')"
        width="160">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.id" path="/invoices/" :label="scope.row.inv_number"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        :label="$t('common.date')"
        width="120">
        <template slot-scope="scope">
          <span>{{_moment(scope.row.date)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="customer.name"
        :show-overflow-tooltip="true"
        :label="$t('clients.name')">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.customer.id" path="/customers/" :label="customerName(scope.row.customer)"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        prop="total"
        :show-overflow-tooltip="true"
        align="center"
        :label="$t('invoices.amount')"
        width="150">
        <template slot-scope="scope">
          <span>{{$n(scope.row.total,'currency',scope.row.currency.code)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="balance.outstanding"
        :show-overflow-tooltip="true"
        align="center"
        :label="$t('common.outstanding')"
        width="150">
        <template slot-scope="scope">
          <span>{{$n(scope.row.balance.outstanding,'currency',scope.row.currency.code)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status.code"
        :label="$t('invoices.status')"
        align="center"
        width="190"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag size="mini" :type="getInvoiceTagType(scope.row.status)" style="margin-left:10px;">{{$t("invoices.statuses."+scope.row.status.code)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        :label="$t('invoices.paidAt')"
        width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.paid_at">{{_moment(scope.row.paid_at)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label=""
        width="60">
        <template slot-scope="scope">
          <span class="fr-14 secondary-text" style="text-align:right;">
            <InvoiceNoticeStatus :notice_status="scope.row.notice_status"></InvoiceNoticeStatus>
            <i v-if="scope.row.files.length>0" class="el-icon-paperclip"></i>
          </span>
        </template>
      </el-table-column>
      <!-- <infinite-loading
        slot="append"
        ref="infiniteLoading"
        @infinite="load"
        force-use-infinite-wrapper=".el-table__body-wrapper">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading> -->
    </el-table>
    </div>
    <invoiceFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></invoiceFilter>
    <waitingDialog :visible="waitingDialogVisible" :title="waitingTitle"></waitingDialog>
    <el-dialog :title="$t('invoices.invoicesNotSent')" :visible.sync="invoicesNotSendDialogVisible">
    <el-table :data="invoicesNotSent">
      <el-table-column property="inv_number" label="# facture">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.id" path="/invoices/" :label="scope.row.inv_number"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column  label="Client">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.customer.id" path="/customers/" :label="customerName(scope.row.customer)"></PortausLink>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
  </div>
</template>
<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  import Promise from 'bluebird'
  import invoiceAPI from '@/services/API/invoice'
  import moment from 'moment-timezone'
  import invoiceFilter from './invoice-filter'
  import InvoiceTile from '@/components/invoice/Invoice-tile'
  import PortausLink from '@/components/portaus-link'
  import InvoiceNoticeStatus from '@/components/invoice/invoice-notice-status'
  import waitingDialog from '@/components/waiting-dialog'
  import customerAPI from '@/services/API/customer'
  import Pagination from '@/components/pagination'

  export default {
    name: 'Invoices-List',
    props: {

  	},
    data() {
      return {
        selected: [],
        invoicesNotSent : [],
        showFilters : false,
        index : null,
        active_el : null,
        stats : {
          count  :0
        },
        window: {
          width: 0,
          height: 0
        },
        waitingDialogVisible : false,
        waitingTitle : "Envoi en cours",
        invoicesNotSendDialogVisible : false,
      };
    },components: {
      invoiceFilter,
      InvoiceTile,
      PortausLink,
      InvoiceNoticeStatus,
      waitingDialog,
      Pagination,
    },
    watch : {

    },
  	methods: {
      sendInvoices(){
        let _this = this;
        this.invoicesNotSent = [];
        this.$confirm('Vous allez envoyer ' + this.selected.length + ' avis de facturation! Ceci pourrait prendre plusieurs secondes. Voulez-vous continuer?', 'Warning', {
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(() => {
          this.waitingDialogVisible = true;
          return Promise.each(this.selected, (i) => {
            // console.log("invoice : ", i);
            return customerAPI.getCustomer(i.customer.id)
              .then(customer => {
                let contactList = [];
                let sendTo = [];
                let invoiceNoticeContent = this.defaultInvoiceNoticeContent(i.customer.language != null ? i.customer.language.code : 'fr');
                // console.log("customer : ", customer);
                if(customer.email_custom_content!=null && customer.email_custom_content.INVOICE_NOTICE!=null){
                  let emailCustomContent = _.find(_this.invoiceNoticeEmailCustomContent, t=>{return t.id==customer.email_custom_content.INVOICE_NOTICE})
                  // console.log("CustomContent detected : ", emailCustomContent)
                  if(emailCustomContent!=null)invoiceNoticeContent=emailCustomContent.content[customer.language.code];
                }


                // //On popule la liste des contacts
                if(customer.company!=null){
                  _.forEach(customer.company.contacts, c=>{
                      if(c.active){
                        contactList = _.uniqBy(_.concat(contactList,c), 'id');
                      }
                  })
                } else {
                  contactList = _.uniqBy(_.concat(contactList,customer.contact), 'id');
                }

                if(contactList.length==1){
                  sendTo = contactList;
                }else{
                  _.forEach(contactList, c=>{
                    if(i.billing_contact!=null && c.id==i.billing_contact.id){
                      sendTo = _.uniqBy(_.concat(sendTo,{id:c.id, last_name: c.last_name, first_name: c.first_name, email : c.work_email!=null && c.work_email!='' ? c.work_email : c.email}), 'id');
                    }
                    else if(c.default_billing_ind) {
                      sendTo = _.uniqBy(_.concat(sendTo,{id:c.id, last_name: c.last_name, first_name: c.first_name, email : c.work_email!=null && c.work_email!='' ? c.work_email : c.email}), 'id');
                    }
                    else if(c.send_invoice_notice) {
                      sendTo = _.uniqBy(_.concat(sendTo,{id:c.id, last_name: c.last_name, first_name: c.first_name, email : c.work_email!=null && c.work_email!='' ? c.work_email : c.email}), 'id');
                    }
                  })
                }
                if(sendTo.length > 0) {
                  return invoiceAPI.sendInvoiceNotification(i.id,sendTo,invoiceNoticeContent,customer.language.code)
                    .catch(err=>{
                      this.invoicesNotSent.push(i);
                    })
                } else {
                  this.invoicesNotSent.push(i);
                }

              })
          }).then(() => {
            if(this.invoicesNotSent.length == 0){
              this.$message({
                type: 'success',
                message: 'Envoi terminé'
              });
            }else{
              this.invoicesNotSendDialogVisible = true;
              this.$message({
                type: 'warning',
                message: "Certaine(s) facture(s) n'ont pu être envoyée(s)"
              });
            }

            this.waitingDialogVisible = false;
          }).catch((err) => {
            console.log(err);
            this.waitingDialogVisible = false;
          })

        }).catch((err) => {
          // console.log(err);
          this.$message({
            type: 'info',
            message: 'Envoi annulé!'
          });
          this.waitingDialogVisible = false;
        });

      },
      downloadCSV(){
        const invoiceIds = _.map(this.selected,'id');
        this.downloading=true;
        invoiceAPI.downloadExtractInvoicesCSV(invoiceIds, 'invoices_csv_extract')
          .then(invoices=>{
            this.downloading=false;
          }).catch(err=>{
            this.$message.error('Oops! Une erreur est survenue!')
            this.downloading=false;
          })
      },
      handleSelectionChange(val){
        this.selected = val;
      },
      // load($state) {
  		// 	if(this.page <= this.pages){
  		// 		this.fetchNextInvoicesPage()
  		// 			.then(()=>{
  		// 				if($state){
  		// 					$state.loaded();
  		// 				}
  		// 			})
  		// 	}else{
  		// 		if($state)$state.complete();
  		// 	}
      // },
  		loadCount(){
  			invoiceAPI.fetchInvoices({count:''})
  				.then(stats=>{
  					this.stats.count = stats.count;
  				})
  		},
      _moment(datetime){
  			return  moment(datetime).format('DD/MM/YYYY');
  		},
      handlePageChange(val){
        this.changePage(val);
      },
      formatAmount(amount){
        return parseFloat(amount).toFixed(2);
      },
      calculatePOTotalAmount(so){
        return so.total_amount_items+so.adjustment;
      },
      sortBy(orderName){

        if(this.orderBy.orderName!=orderName){
          this.orderBy={orderName : orderName, direction:'DESC'};
          this.sort_icon = this.icons['DESC'];
        }else{
          if(this.orderBy.direction=='DESC'){
            this.orderBy={orderName : orderName, direction:'ASC'};
            this.sort_icon = this.icons['ASC'];
          }else{
            this.orderBy={orderName : orderName, direction:'DESC'};
            this.sort_icon = this.icons['DESC'];
          }
        }
      },
      sortIcon(orderName){
        return orderName==this.orderBy.orderName?this.sort_icon:'';

      },
      selectSO(so,index){
        this.$emit('select',so,index);
      },
      moment(datetime){
  			return  moment(datetime).format('LL');
  		},
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      defaultInvoiceNoticeContent(languageCode){
        return this.$i18n.t('invoices.notification.default_'+languageCode);
      },
      ...mapActions('invoices', ['fetchPreviousPage', 'fetchNextPage', 'setSearchTerms','changeOrderBy','changeSortIcon','changePage','fetchInvoices','fetchNextInvoicesPage','resetFilters']),
      ...mapGetters('invoices', ['getOrderBy', 'getSortIcon']),
      ...mapActions('controlData',['fetchEmailCustomContent'])
  	},
  	computed: {

      orderBy : {
  			set(val){this.changeOrderBy(val)},
  			get(){return this.getOrderBy()}
  		},sort_icon : {
  			set(val){this.changeSortIcon(val)},
  			get(){return this.getSortIcon()}
  		},
      search : {
          set(val){ this.setSearchTerms(val)},
          get(){return this.searchTerms}
      },
      getHeight(){
  			return (this.window.height-300);
  		},
      getHeightStyle(){
        return "height:" + (this.window.height-242) + "px;";
      },
      ...mapState('invoices', ['searchTerms','loading','selectedInvoice','icons', 'invoices','page','pages','limit', 'count', 'mode']),
      ...mapGetters('invoices', ['getInvoiceTagType','isFiltered','getNbFiltersCriteria']),
      ...mapGetters('customers', ['customerName']),
      ...mapGetters('controlData',['invoiceNoticeEmailCustomContent'])
  	},
    mounted(){
      this.fetchInvoices();
      this.loadCount();
    },
  	created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      this.fetchEmailCustomContent();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


  .active{
    background-color: lighten($background-color, 20%);
    border-radius: 5px;
    box-shadow:none;
    box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
  }

  .select-info{
    flex: 0 0 360px;
  }

  .search-box{
    flex: 1;
  }

  .filter-button{
    min-width:180px;
  }

  .item-list {
    //margin: 0 auto;
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;

    .item {
      margin: 10px 0;
      padding: 5px;
      box-sizing: border-box;
      cursor: pointer;
      transition: all .5s .25s;


      .info {
        word-break: break-word;

      }

      &:hover {
        //margin: 15px -20px;
        //padding: 10px;
        background-color: lighten($background-color, 20%);
        border-radius: 5px;
        box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

      }

    }
  }

  @media (max-width: 1024px) {
    .filter-button{
      min-width:30px;
    }

    .search-box{
      flex: 1 100%;
    }


    .select-info{
      flex: 1 100%;
      margin-bottom:10px;
      height:30px;
    }
  }

  </style>
